import { render, staticRenderFns } from "./order-delivery-details-form.vue?vue&type=template&id=0bc62e32&scoped=true&lang=pug&"
import script from "./order-delivery-details-form.vue?vue&type=script&lang=js&"
export * from "./order-delivery-details-form.vue?vue&type=script&lang=js&"
import style0 from "./order-delivery-details-form.vue?vue&type=style&index=0&id=0bc62e32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc62e32",
  null
  
)

export default component.exports